import PropTypes from 'prop-types';
import React from 'react';

import { AppTabsRouter, AppTabsRouterItem } from '@/components/app-layout/TabsRouter';

const propTypes = {
  id: PropTypes.string,
};

export default function OfferSubTabs({ id }) {
  return <AppTabsRouter>
    <AppTabsRouterItem exact to={`/offer/offers/${id}`}>
      Details
    </AppTabsRouterItem>
    <AppTabsRouterItem exact to={`/offer/offers/${id}/attributes`}>
      Attributes
    </AppTabsRouterItem>
  </AppTabsRouter>
}

OfferSubTabs.propTypes = propTypes
OfferSubTabs.defaultProps = {}
